import { isEmpty } from 'lodash';
import { getName } from './getName';
import { parseName } from './parseName';

export default function getFormFieldValues(fields, stripePaymentMethodEvent = null) {
  const fieldArray = Object.keys(fields)
    .filter(key => !isEmpty(fields[key]))
    .map(key => ({
      fieldId: fields[key]._id,
      label: fields[key].label,
      value: fields[key].value,
      meta: fields[key].meta,
      type: fields[key].type,
      element: fields[key].element,
      reference: fields[key].reference,
    }))
    .map(field => {
      if (field.element === 'date-time' && field.value) {
        field.value = new Date(field.value).toISOString();
      }

      if (field.element === 'date' && field.value) {
        // for date, we want to append the users current time
        // to the date so that we get the correct date in the
        // users timezone
        const date = new Date(field.value);
        const time = new Date();
        date.setHours(time.getHours());
        date.setMinutes(time.getMinutes());
        date.setSeconds(time.getSeconds());
        field.value = date.toISOString();
      }

      return field;
    });

  let nameField = fieldArray.find(field => field.type === 'name');
  let firstNameField = fieldArray.find(field => field.type === 'first-name');
  let lastNameField = fieldArray.find(field => field.type === 'last-name');
  let name = getName(fieldArray);
  let emailField = fieldArray.find(field => field.type === 'email');
  let email = emailField?.value;

  if (stripePaymentMethodEvent && stripePaymentMethodEvent.billingDetails) {
    const { billingDetails } = stripePaymentMethodEvent;
    const { name: billingDetailsName, email: billingDetailsEmail } = billingDetails;

    if (billingDetailsName && !name) {
      name = billingDetailsName;

      // if the name fields exists and the name is not set, set the name field
      // this happens on express apple/google pay payments
      if (nameField) {
        nameField.value = billingDetailsName;
      }

      try {
        // parse the name into first and last name
        const { firstName, lastName } = parseName(billingDetailsName);

        if (firstNameField) {
          firstNameField.value = firstName;
        }

        if (lastNameField) {
          lastNameField.value = lastName;
        }
      } catch (e) {
        // do nothing
      }
    }

    if (billingDetailsEmail && !email) {
      email = billingDetailsEmail;

      // if the email fields exists and the email is not set, set the email field
      // this happens on express apple/google pay payments
      if (emailField) emailField.value = billingDetailsEmail;
    }
  }

  return {
    fields: fieldArray,
    name,
    email,
  };
}
